import auth0 from "auth0-js";
import authConfig from "../../auth_config.json";
import Auth0Lock from "auth0-lock";

export default new auth0.WebAuth({
    domain: authConfig.domain,
    clientID: authConfig.managerId,
    redirectUri: `${window.location.origin}/callback`,
    responseType: "token id_token",
    scope: "openid profile email",
    audience: "https://givemagic-admin.auth0.com/api/v2/"
});

export const lock = new Auth0Lock(authConfig.managerId, authConfig.domain);
